import UIBaseComponent from "@baseUI/component/base/UIBaseContainer";

export default class BaseButtonComponent extends UIBaseComponent {

    constructor(hitArea) {
        super()

        this.isOut = true
        this._hitArea = hitArea;
    }

    init(textures) {
        this.textures = textures
        this.button = new PIXI.Sprite(this.textures.up)

        if (this._hitArea) {
            this.button.hitArea = this._hitArea;
        }

        this.button
            .on('pointerup', this.onButtonUp, this)
            .on('pointerdown', this.onButtonDown, this)
            .on('pointerover', this.onButtonOver, this)
            .on('pointerupoutside', this.onButtonUp, this)
            .on('pointerout', this.onButtonOut, this)
        this.button.interactive = true
        this.button.buttonMode = true

        this.button.anchor.set(0.5)
        this.addChild(this.button)

        this._unvisible = false
    }

    onButtonUp (e) {
        e.stopPropagation()
        if(this.disabled || this.disabledManually) {return}
        if(this.isOut) {
            this.button.texture = this.textures.over
        } else {
            this.button.texture = this.textures.up
            this.emit('tapButton')
        }
    }

    onButtonDown (e) {
        if(this.disabled || this.disabledManually) {return}
        this.isOut = false
        this.button.texture = this.textures.down
    }

    onButtonOver (e)  {
        if(this.disabled || this.disabledManually) {return}
        this.isOut = false
        this.button.texture = this.textures.over
        this.emit('overButton')
    }

    onButtonOut (e)  {
        if(this.disabled || this.disabledManually) {return}
        this.isOut = true
        this.button.texture = this.textures.up
        this.emit('outButton')
    }

    disable() {
        this.disabled = true
        this.button.buttonMode = false
        this.isOut = true
        this.button.texture = this.textures.disable
    }

    enable() {
        this.disabled = false
        this.button.buttonMode = true
        if(this.isOut) {
            this.button.texture = this.textures.up
        } else {
            this.button.texture = this.textures.over
        }
    }

    set unvisible(value){
        this._unvisible = value
    }

    get unvisible(){
        return this._unvisible
    }

    show() {
        this.visible = true && !this._unvisible
    }

    destroy() {
        super.destroy()
        this.button
            .off('pointerup', this.onButtonUp, this)
            .off('pointerdown', this.onButtonDown, this)
            .off('pointerover', this.onButtonOver, this)
            .off('pointerupoutside', this.onButtonUp, this)
            .off('pointerout', this.onButtonOut, this)
        this.button.interactive = false
    }

}
